<!-- pcs-wrap: maneja el scroll horizontal -->
<!-- pcs: ancho = max-content + margin auto → se centra cuando cabe, parte desde la izq cuando desborda -->
<div
  class="pcs-wrap"
  [class.pcs-wrap--disabled]="isLocked()"
  aria-label="Seleccione un producto">
  <div class="pcs">
    @if (products().length === 0) {
      <p class="pcs__empty">No hay productos disponibles para la zona seleccionada.</p>
    }
    @for (product of products(); track product.id) {
      <button
        type="button"
        class="pcs__card"
        [class.pcs__card--selected]="isSelected(product)"
        [disabled]="isLocked()"
        [attr.aria-pressed]="isSelected(product)"
        (click)="select(product)">
        <div class="pcs__img-wrap">
          <img
            [src]="getImageUrl(product)"
            [alt]="getLabel(product)"
            class="pcs__img"
            loading="lazy"
            (error)="onImageError($event)" />
          @if (isSelected(product)) {
            <span class="pcs__check" aria-hidden="true"></span>
          }
        </div>
        @if (selecting && isSelected(product)) {
          <div class="pcs__loading" aria-hidden="true">
            Seleccionando...
          </div>
        }
        <div class="pcs__body">
          <p class="pcs__name">{{ getLabel(product) }}</p>
        </div>
        <div class="pcs__footer">
          {{ isSelected(product) ? 'Seleccionado' : 'Seleccionar' }}
        </div>
      </button>
    }
  </div>
</div>
